<div class="page-wrapper">
    <div class="dialog-content">
        <div class="logo-wrapper">
            <div class="upgrade-logo">
                <img src="../../../assets/icons/upgrade.svg" alt="" width="32" />
            </div>
        </div>
        <!-- <div class="cross-button" (click)="closeUpdatePage()"><span>X</span></div> -->
        <div class="upgrade-heading">Upgrade to a Paid Plan</div>
        <div class="upgrade-desc">
            {{ commonService.isPackegeExpiredDescription ? commonService.isPackegeExpiredDescription : 'You have reached your current package limit. You can increase your limit by
            upgrading your account or wait until next month.' }}
        </div>
        <!-- <div>
      <button class="upgrade-button" (click)="upgradePlan()">Upgrade</button>
    </div> -->
        <div class="btn-wrapper">
            <div class="cancel-btn" (click)="closeUpdatePage()">Cancel</div>
            <div class="upgrade-btn" (click)="upgradePlan()">Upgrade Plan</div>
        </div>
    </div>
</div>